export default "//static.tradera.net/touchweb/static/output/images/tradera_new.96daad55.svg";